import { BreadcrumbService } from 'src/app/angularJS/services/breadcrumbs/breadcrumb.service';
import { SpecialDayService } from 'src/app/angularJS/services/special-day/special-day.service';
import { UserMessagesService } from 'src/app/angularJS/services/user-messages.service';
import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service';
import { LinkBuilder } from 'src/app/angularJS/services/link-builder.service';
import { UserService } from 'src/app/angularJS/services/user/user.service';
import { QueryBuilder } from 'src/app/angularJS/services/query-builder.service';
import { TransportOperatorService } from 'src/app/angularJS/services/transport-operator/transport-operator.service';
import { DialogService } from 'src/app/angularJS/services/dialog/dialog.service';

export class SpecialDaysController {
  public static $inject = [
    'breadcrumbService',
    'specialDayService',
    '$rootScope',
    'UserMessages',
    'ACTToolbarService',
    'PrimaryAction',
    'LinkBuilder',
    'userService',
    'QueryBuilder',
    '$translate',
    'transportOperatorService',
    'dialogService'
  ];

  public specialDays: Array<InterACT.Interfaces.SpecialDays.SpecialDay> = [];
  public operators: Array<InterACT.Interfaces.TransportOperators.TransportOperator> = [];
  public currentLocale: string;
  public filters: { operator: InterACT.Interfaces.TransportOperators.TransportOperator, year: string } = {
    operator: undefined,
    year: undefined
  };
  public paginatorData: InterACT.Interfaces.IPaginationData = {
    totalCount: 0,
    perPageCount: 15,
    currentPage: 1
  };

  constructor(
    private breadcrumbService: BreadcrumbService,
    private specialDayService: SpecialDayService,
    private $rootScope: ng.IRootScopeService,
    private userMessagesService: UserMessagesService,
    private toolbarService: ACTToolbarService,
    private primaryActionService: any,
    private linkBuilder: LinkBuilder,
    private userService: UserService,
    private queryBuilder: QueryBuilder,
    private $translate: ng.translate.ITranslateService,
    private transportOperatorService: TransportOperatorService,
    private dialogService: DialogService
  ) {
    -
      this.activate();
  }

  /**
   * A function that retrieves a given page of special days
   * @param page the page number to retrieve
   * @param perPageCount the amount of special days to retrieve per page
   */
  public getData = (page: number, perPageCount: number) => {
    if (!page) {
      page = this.paginatorData.currentPage;
    }

    if (!perPageCount) {
      perPageCount = this.paginatorData.perPageCount;
    }

    this.queryBuilder.newParam()
      .fieldIs('scheme.link', this.linkBuilder.getSchemesLink(this.userService.selectedScheme.id));

    if (this.filters.operator !== undefined && (<any>this.filters.operator) !== 'Any') {
      this.queryBuilder
        .and()
        .fieldIs('operators.link', this.linkBuilder.getTransportOperatorsLink(this.filters.operator.id));
    }

    if (this.filters.year !== undefined && this.filters.year.length === 4) {
      this.queryBuilder
        .and()
        .isGreaterOrEqualTo('date', this.filters.year + '-01-01T00:00:00Z')
        .and()
        .isLessThanOrEqualTo('date', this.filters.year + '-12-31T23:59:59Z')
    }

    this.queryBuilder
      .sortBy([{
        columnName: 'date',
        direction: 'desc'
      }]);

    this.$rootScope.showSpinner = true;
    this.specialDayService.getList(page, perPageCount, this.queryBuilder.getParam()).then((response) => {
      this.paginatorData.totalCount = response.meta.totalCount;
      this.specialDays = response.specialDays.map((specialDayWithMeta) => {
        return specialDayWithMeta.specialDay;
      });

      this.$rootScope.showSpinner = false;
    });
  };

  /**
   * A function to change the operator links from an array into a string
   * @param operatorLinks the operatorLinks to be converted
  */
  public getOperatorNamesForSpecialDay = (operatorLinks: Array<InterACT.Interfaces.TransportOperatorServices.OperatorLink>) => {
    if (operatorLinks.length === 0) {
      return this.$translate.instant("SPECIAL_DAYS.ANY");
    }

    const operatorNames = operatorLinks.map((operatorLink) => {
      return operatorLink.name;
    });

    return operatorNames.join(', ');
  }

  /**
   * A function to spawn a dialog to create a new special day
   */
  public createSpecialDay = () => {
    const specialDay: InterACT.Interfaces.SpecialDays.SpecialDay = {
      scheme: {
        link: this.linkBuilder.getSchemesLink(this.userService.selectedScheme.id),
        abbreviation: this.userService.selectedScheme.reference
      },
      name: undefined,
      date: undefined,
      operators: []
    };

    this.dialogService.showSpecialDayDialog(specialDay).then((specialDay) => {
      this.specialDayService.create(specialDay).then(() => {
        this.getData(this.paginatorData.currentPage, this.paginatorData.perPageCount);
      });
    });
  };

  /**
   * A function that spawns a dialog to manage the supplied special day
   * @param specialDay the special day to be managed
   */
  public editSpecialDay = (specialDay: InterACT.Interfaces.SpecialDays.SpecialDay) => {
    const specialDayCopy = JSON.parse(JSON.stringify(specialDay));
    this.dialogService.showSpecialDayDialog(specialDayCopy).then((editedSpecialDay) => {
      this.specialDayService.update(editedSpecialDay).then(() => {
        this.getData(this.paginatorData.currentPage, this.paginatorData.perPageCount);
      });
    });
  };

  /**
   * A function that deletes the special day with the supplied id
   * @param specialDayId the id of the day to delete
   */
  public deleteSpecialDay = (specialDayId: string) => {
    this.userMessagesService.buildConfirmDialog(
      'DELETE_SPECIAL_DAY',
      'CONFIRM_DIALOG.SPECIAL_DAYS.DELETE_CONFIRM',
      undefined,
      'CONFIRM_DIALOG.SPECIAL_DAYS.CONFIRM',
      'CONFIRM_DIALOG.SPECIAL_DAYS.CANCEL'
    ).then(() => {
      this.specialDayService.delete(specialDayId).then(() => {
        this.userMessagesService.showToast('SPECIAL_DAYS.DAY_DELETED');
        this.getData(this.paginatorData.currentPage, this.paginatorData.perPageCount);
      });
    });
  };

  /**
   * A function to get all the operators on the current scheme
   */

  public getOperatorsForScheme = () => {
    const query = this.queryBuilder.newParam().fieldIs('schemes.link', this.linkBuilder.getSchemesLink(this.userService.selectedScheme.id)).getParam();
    this.transportOperatorService.getList(1, 100, query).then((response) => {
      this.operators = response.transportOperators;
    });
  };

  /**
   * A function to reset the data if a filter is selected
   */
  public onFilterChanged = () => {
    this.getData(this.paginatorData.currentPage, this.paginatorData.perPageCount);
  };

  /**
   * A function to check the length of the year filter and if it is 4 characters calls the onFilterChanged function
   */
  public checkYearFilter = () => {
    if (this.filters.year.length === 4 || this.filters.year.length === 0) {
      this.onFilterChanged();
    }
  };

  /**
   * A function to check if there are any special days
   * returns boolean if there are no specialDays
   */
  public shouldShowNoSpecialDaysLabel = () => { return this.specialDays.length === 0 };

  /**
   * A function that gets called during controller instantiation
   */
  private activate() {
    this.primaryActionService.setActions([{
      name: 'CREATE_SPECIAL_DAY',
      action: this.createSpecialDay
    }]);

    this.breadcrumbService.setBreadcrumbs([{
      name: 'ABT_CONFIGURATION',
      sref: '#'
    }, {
      name: 'SPECIAL_DAYS.SPECIAL_DAYS',
      sref: undefined
    }]);

    this.toolbarService.getToolbar('primary').then((toolbarController) => {
      toolbarController.setTitle('SPECIAL_DAYS.SPECIAL_DAYS');
    });

    this.currentLocale = this.$translate.use();

    this.getOperatorsForScheme();
  }
}
